import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvalidLinkLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InvalidLink" */
      './InvalidLink.dynamic'
    ),
  loading: LoadingPageLoadable,
});
